import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { Dealer } from "src/app/shared/models/Dealer.model";
import { License } from "src/app/shared/models/license.model";

@Component({
	selector: "app-dealer-list",
	templateUrl: "./dealer-list.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class DealerListComponent implements OnInit {
	@Output() dealerIdSelectedEmitter = new EventEmitter<string>();
	dealerList: Dealer[];

	focusLinkLicenses: License[] = [];
	licensedVenues: number = 0;
	venues: number = 0;

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.getDealers();
	}

	async getDealers() {
		const resp = await this.focuslink.dealersGet();
		this.dealerList = resp.map((i) => new Dealer(i)).sort((a, b) => (a.name > b.name ? 1 : -1));
		this.parseDealers(this.dealerList);
	}

	parseDealers(dealers: Dealer[]) {
		dealers.forEach((dealer) => {
			if (dealer.venues) {
				dealer.venues.forEach((venue) => {
					this.venues += 1;
					if (venue.licenses && venue.licenses.length > 0) {
						if (venue.licenses.length > 1 && venue.licenses.some((lic) => lic.type !== "connector")) {
							this.licensedVenues += 1;
						}
					}
					venue.licenses.forEach((license) => {
						if (license.type !== "connector") {
							this.focusLinkLicenses.push(license);
						}
					});
				});
			}
		});
	}
}
